var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2107 2.83508L13.1656 1.79008C12.6206 1.24508 11.5756 1.40508 10.8356 2.15008L2.60062 10.3851C2.50062 10.4851 2.43062 10.6051 2.39562 10.7301L1.87062 12.6251L1.49062 13.9901C1.39062 14.3551 1.64562 14.6101 2.01062 14.5101L3.37562 14.1301L5.27063 13.6051C5.39563 13.5701 5.51563 13.5001 5.61563 13.4001L13.8456 5.17008C14.5907 4.42508 14.7507 3.38508 14.2057 2.84008L14.2107 2.83508Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9466 4.84932L11.1516 2.05434C11.0416 1.93934 10.7766 2.20934 10.8916 2.31434L13.6866 5.10932C13.7966 5.22432 14.0616 4.95432 13.9466 4.84932Z",
    fill: "#000105"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67316 13.1198L2.87818 10.3248C2.76818 10.2098 2.50318 10.4798 2.61818 10.5848L5.41316 13.3798C5.52316 13.4948 5.78816 13.2248 5.67316 13.1198Z",
    fill: "#000105"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.a1cf096b2a85a9124410c63cdbed5215.svg";
export { ForwardRef as ReactComponent };